import { Component, Input } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    StripeService, PriceService, Receipt, AccountService, TeamEvent, Ticket, Merchandise
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
declare var Stripe: any;

/**
 * Generated class for the StripeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'receipt',
    templateUrl: 'receipt.html'
})
export class ReceiptComponent extends BaseComponent {
    @Input() public receipt: Promise<Receipt> | null;

    private ticketsGrouped: Promise<{ Event: TeamEvent, Tickets: Ticket[] }[]> | null = null;

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected accountService: AccountService,
        protected stripeService: StripeService,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "ReceiptComponent"
        );
    }

    ngOnInit() {
        super.ngOnInit();

        this.receipt.then((receipt) => {
            this.ticketsGrouped = new Promise<{ Event: TeamEvent, Tickets: Ticket[], NTI: Merchandise[] }[]>((resolve, reject) => {
                let result: { Event: TeamEvent, Tickets: Ticket[], NTI: Merchandise[] }[] = [];

                if (receipt.tickets && receipt.tickets.length > 0) {
                    for (let ticket of receipt.tickets) {
                        var tg = result.filter(p => (p.Event || { EventID: 0 }).EventID == ticket.EventID);
                        if (tg.length > 0) {
                            tg[0].Tickets.push(ticket);
                        } else {
                            result.push({
                                Event: receipt.events.filter(p => p.EventID == ticket.EventID)[0],
                                Tickets: [ticket],
                                NTI: []
                            });
                        }
                    }
                }

                if (receipt.nti) {
                    for (let nti of receipt.nti) {
                        let tg: { Event: TeamEvent, Tickets: Ticket[], NTI: Merchandise[] }[];
                        if (nti.EventID != -1) {
                            tg = result.filter(p => (p.Event || { EventID: 0 }).EventID == nti.EventID);
                        } else {
                            // this is to handle the ones with EventID == -1
                            tg = result.filter(p => (p.Event || { SponsorID: 0 }).SponsorID == nti.SponsorID);
                            if (tg.length == 0) {
                                tg = result.filter(p => p.Event == null);
                            }
                        }

                        if (tg.length > 0) {
                            tg[0].NTI.push(nti);
                        } else {
                            result.push({
                                Event: nti.EventID != -1 ?
                                    (
                                        (receipt.events || []).filter(p => p.EventID == nti.EventID).length > 0 ?
                                            receipt.events.filter(p => p.EventID == nti.EventID)[0] // we look for the event
                                            :
                                            null // otherwise, put it at the end
                                    )
                                    :
                                    (
                                        (receipt.events || []).filter(p => p.SponsorID == nti.SponsorID).length > 0 ?
                                            receipt.events.filter(p => p.SponsorID == nti.SponsorID)[0] : // if we have any event for this sponsor, we put it there
                                            null // otherwise, we put it at the end of the receipt
                                    ),
                                Tickets: [],
                                NTI: [nti]
                            });
                        }
                    }
                }

                resolve(result);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/receipt/receipt.ts